<template>
    <div class="modal-card card">
        <form @submit.prevent="onFormSubmit()">
            <div class="card-header">
                <!-- Title -->
                <h4 class="card-header-title">Delete Users</h4>
                <!-- Close -->
                <button
                    type="button"
                    class="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                ></button>
            </div>
            <div class="card-body">
                <p>Are you sure you want to delete the following users?</p>
                <ul class="list-group list-group-flush">
                    <li v-for="item in users" :key="item.index" class="list-group-item py-2 delete-cred-item fs-5 border-0">
                        <i class="fa-solid fa-user me-2 opacity-75 text-primary"></i>
                        <span class="ms-1">{{item.name}} ({{item.email}})</span>
                    </li>
                </ul>
                <div class="mt-3 py-3 px-3 rounded warning-alert" style="border-left: 4px solid #f59e0b; background-color: #ffc1071a;">
                    <span class="warning-alert-text">
                        <i class="fa fa-triangle-exclamation me-1"></i>
                        This action cannot be undone. Any tokens issued to the users will be invalidated
                    </span>
                </div>
            </div>
            <div class="card-footer text-end">
                <button class="btn btn-danger">
                    <div
                        v-if="deleteInProgress"
                        class="spinner-border spinner-border-sm"
                        role="status"
                        >
                        <span class="visually-hidden">Loading...</span>
                    </div>
                    <div v-else><slot></slot>Delete</div>
                </button>
            </div>
        </form>
    </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
    data() {
        return {
            error: "",
            user: {},
            users: [],
            deleteInProgress: false
        };
    },
    props: {
       modalData: {
            type: Object,
            default: () => ({})
        }
    },
    name: "DeleteUsers",
    methods: {
        ...mapActions("admin", {
            deleteUser: "deleteUser",
        }),
        async onFormSubmit() {
            this.deleteInProgress = true;
            try {
                for (const user of this.users) {
                    await this.deleteUser(user)
                    if (this.modalData && this.modalData.onDeleteUser && typeof this.modalData.onDeleteUser === 'function') {
                        this.modalData.onDeleteUser(user);
                    }
                }
            } catch (error) {
                if (error.response.data.error)
                    this.error = error.response.data.error;
                else this.error = error.message;
                return;
            } finally {
                this.deleteInProgress = false;
            }

            this.$store.dispatch("hideModal");
            this.$store.dispatch("admin/fetchUsers");
        },
    },
    beforeMount() {
        this.users = this.modalData?.rows || [];
    }
};
</script>

<style>
.warning-alert-text {
    color: #f59e0b;
    font-size: 0.85rem;;
}
.warning-alert {
    border-left: 3px solid #f59e0b;
    background-color: #ffc1071a;
}
</style>
<style lang="scss">
body.dark-mode {
    .warning-alert-text {
        color: var(--bs-warning);
    }
    .warning-alert {
        border-left: 3px solid var(--bs-warning);;
    }
}
</style>